import { createSlice } from '@reduxjs/toolkit';
import { ASSETS_PREVIEW } from '@/types/shared/navigation-tabs.enums';
interface assetsStudioState {
  metric: 'duration' | 'count';
  group_by: 'components' | 'alarms' | 'assets';
  top_ranked?: number;
  asset_types?: string[] | null;
  from_date?: string;
  to_date?: string;
  selectedPriority: string[];
  asset_ids?: string[] | null;
  component_ids?: string[] | null;
  selectedSeverity: string[];
  selectedInterface: string[];
  add_metadata?: boolean;
}

const initialState: assetsStudioState = {
  metric: 'count',
  top_ranked: 20,
  group_by: 'components',
  asset_types: null,
  selectedPriority: [],
  asset_ids: null,
  component_ids: null,
  selectedSeverity: [],
  add_metadata: true,
  selectedInterface: [],
};

const externalAlarmsSlice = createSlice({
  initialState,
  name: 'exteralAlarms',
  reducers: {
    setMetric(state, action) {
      state.metric = action.payload;
    },
    setTopRanked(state, action) {
      state.top_ranked = action.payload;
    },
    setGroupBy(state, action) {
      state.group_by = action.payload;
    },
    setSelectedPriority(state, action) {
      state.selectedPriority = action.payload;
    },
    setAssetsIds(state, action) {
      state.asset_ids = action.payload === ASSETS_PREVIEW.ALL_ASSETS ? null : [action.payload];
    },
    setComponentIds(state, action) {
      if (action.payload !== 'all-components') state.group_by = 'alarms';
      else state.group_by = 'components';
      state.component_ids = action.payload === 'all-components' ? null : [action.payload];
    },
    setSelectedSeverity(state, action) {
      state.selectedSeverity = action.payload;
    },
    setSelectedInterface(state, action) {
      state.selectedInterface = action.payload;
    },
    setAddMetadata(state, action) {
      state.add_metadata = action.payload;
    },
  },
});

export const ExternalAlarmsSliceReducer = externalAlarmsSlice.reducer;
export const {
  setAssetsIds,
  setComponentIds,
  setGroupBy,
  setMetric,
  setSelectedPriority,
  setSelectedSeverity,
  setTopRanked,
  setAddMetadata,
  setSelectedInterface,
} = externalAlarmsSlice.actions;
